import CheckInOut from './CheckInOut';

export default CheckInOut;
